import {styled, Typography} from '@mui/material';

export const TalkingPointDescription = styled(Typography)(({theme}) => ({
  fontSize: theme.typography.pxToRem(14),
  lineHeight: '1.3em',
  marginBottom: theme.typography.pxToRem(12),
}));
